'use strict';

/*
 * 配置编译环境和线上环境之间的切换
 * BASE_URL: 域名地址
 *
 * 注意，在做 URL 映射的时候，惊奇的发现，如果域名在国内，映射香港服务器，
 *
 */
/**
 * 注意，这里是 frontend 运行时的 process.env 的环境，它必须通过 webpack.DefinePlugin 载入，参考 webpack.dev.conf.js 48-49 行以及
 * webpack.prod.conf.js 和 webpack.hybrid-app.conf.js 中的响应配置。这里主要要区别于构建时候 process.env，那个是在构建开始的时候，分别
 * 在 build.js, build-hybrid-app.js 中单独设置的。
 */
console.log('RPOCESS ENV', JSON.stringify(process.env));  // 这句 log 很重要，可以分析出 process.env 是否设置正确与否
console.log('NODE_ENV', process.env.NODE_ENV);
console.log('APP_ENV', process.env.APP_ENV);

import {isExpectedSpider} from "../src/utils";

let VERSION = "1.0.0";  // pay attention, VERSION should be a String if '3.0.1' the number could not recoginze it.

let _BACKEND_BASE_URL = null
let _IMAGE_BASE_URL = null

// TODO 参考 service-worker.js 中的做法，使用 location 拼接出当前的 req scheme
if (process.env.NODE_ENV === 'development') {
    // 注意，如果将下面的访问地址写成 127.0.0.1:6016 的话，即便是正确的设置了 cors，客户端的 cookies 值也不会被写入。
    _BACKEND_BASE_URL = 'http://localhost:6016';
    // _BACKEND_BASE_URL = 'http://192.168.0.187:6016' // at home，记得还要在 backend app.js 中设置好 cors 对应的 IP 地址
    // _BACKEND_BASE_URL = 'http://192.168.33.57:6016' // at maan coffee
    // _IMAGE_BASE_URL = 'http://dev.huocool.com.cn'
    // _IMAGE_BASE_URL = 'http://47.242.80.92';  // 不要在最末添加 `/`，因为拼接的时候，我会添加
    // 使用相关服务器 Redirect 到 OSS，但是因为现在香港 OSS 停用了，因此不再使用了
    // _IMAGE_BASE_URL = 'https://www.huocool.com/img';
    // _IMAGE_BASE_URL = 'http://img2.huocool.kuyufan.com';  // 使用国内 CDN
    _IMAGE_BASE_URL = 'https://img-hc.macooo.com'; // synext 中转服务器直连
} else if (process.env.NODE_ENV === 'testing') {
    _BACKEND_BASE_URL = 'http://'
} else if (process.env.NODE_ENV === 'production') {
    // 记得还有一个地方要改：service-worker.js
    // BACKEND_BASE_URL = 'http://api.huocool.com';  // https://api.huocoo.com，映射后端的 backend api；实测不能这么配置，否则 Ajax 请求会触发 CORS 即同源错误
    // _BACKEND_BASE_URL = 'https://www.huocool.com/api';
    _BACKEND_BASE_URL = 'https://web-huocool.macooo.com/api';  // www.huocool.com 被取代为 web-huocool.macooo.com
    // IMAGE_BASE_URL = 'http://img.huocool.com.cn';    // https://img.huocoo.com，暂时还是不这样设置，因为需要申请两套证书
    // 使用相关服务器 Redirect 到 OSS，但是因为现在香港 OSS 停用了，因此不再使用了
    // _IMAGE_BASE_URL = 'https://www.huocool.com/img';
    // _IMAGE_BASE_URL = 'http://img2.huocool.kuyufan.com';  // 使用国内 CDN
    _IMAGE_BASE_URL = 'https://img-hc.macooo.com'; // synext 中转服务器直连
} else if (process.env.NODE_ENV === 'hybridapp'){
    // TODO 写一个参数区分 hybridapp test / prod 环境
    // 使用本地测试环境
    if (process.env.APP_ENV === 'dev'){
        _BACKEND_BASE_URL = 'http://192.168.0.187:6016' // 这个基本上不会用到，因为 Hybrid app 也是通过本机访问的。
        // _BACKEND_BASE_URL = 'http://localhost:6016';
        // _BACKEND_BASE_URL = 'http://172.20.10.2:6016' // 这是连接手机热点后的电脑 IP 地址，手机可以通过这个 IP 连接电脑，在外办公这个方式是最佳的。
        // _IMAGE_BASE_URL = 'http://dev.huocool.com.cn';
        // _BACKEND_BASE_URL = 'https://huocool.kufan.site/api';
        _IMAGE_BASE_URL = 'https://huocool.kufan.site/img';
    }else if(process.env.APP_ENV === 'prod'){
        // 使用生产环境
        _BACKEND_BASE_URL = 'https://huocool.kufan.site/api';
        _IMAGE_BASE_URL = 'https://huocool.kufan.site/img';
    }
    console.log(`==============> backend base url: ${_BACKEND_BASE_URL}, image base url: ${_IMAGE_BASE_URL}`);
}
else if (process.env.NODE_ENV === 'uat') {
    _BACKEND_BASE_URL = 'http://'
}

//导出
export default{
    BACKEND_BASE_URL: function(){
        // handle for SPA seo only，使能通过内网 localhost:6001 frontend 直接访问内网访问内网 huocool backend 的能力
        if(isExpectedSpider()) {
            _BACKEND_BASE_URL = 'http://localhost:6001/api';
        }
        return _BACKEND_BASE_URL;
    },
    IMAGE_BASE_URL: function(){
        // handle for SPA seo only，使能内网访问 huocool 的能力
        if(isExpectedSpider()) {
            _IMAGE_BASE_URL = 'http://localhost:6001/img';
        }
        return _IMAGE_BASE_URL;
    },
    VERSION
}



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 6